import api from "./api";

export const getServerReport = async () => {
  const { data } = await api.get("/server-report");
  return data;
};
